import { cn } from '@jeraisonne/ui';
import { MarkdownMath } from '@jeraisonne/ui';

/**
 * Bouton de choix QCM partagé — utilisé par le Warmup (et réutilisable par le
 * player guidé). États : non révélé (sélectionnable) → révélé (correct / faux).
 */

export type ChoiceButtonChoice = {
  label_md: string;
  is_correct: boolean;
};

export function ChoiceButton({
  choice,
  index,
  selected,
  revealed,
  onClick,
}: {
  choice: ChoiceButtonChoice;
  /** 0-based — affiché en A, B, C… */
  index: number;
  selected: boolean;
  revealed: boolean;
  onClick: () => void;
}) {
  let cls =
    'w-full text-left rounded-xl border px-4 py-3 text-sm transition-colors active:scale-[.98] min-h-[2.75rem] ';

  if (!revealed) {
    cls += selected
      ? 'border-primary-400 bg-primary-50 font-medium'
      : 'border-ink-200 bg-white hover:border-primary-300 hover:bg-ink-50';
  } else if (choice.is_correct) {
    cls += 'border-xp-300 bg-xp-50 font-medium';
  } else if (selected) {
    cls += 'border-error-300 bg-error-50';
  } else {
    cls += 'border-ink-100 bg-white opacity-50';
  }

  return (
    <button onClick={onClick} disabled={revealed} className={cls}>
      <div className="flex items-start gap-2.5">
        <span
          className={cn(
            'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold',
            revealed && choice.is_correct ? 'bg-xp-500 text-white' : 'bg-ink-100 text-ink-500',
          )}
        >
          {String.fromCharCode(64 + index + 1)}
        </span>
        <div className="min-w-0 flex-1">
          <MarkdownMath>{choice.label_md}</MarkdownMath>
        </div>
      </div>
    </button>
  );
}
